// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: 'actions.filter.title',
        defaultMessage: 'Discover Hive Actions'
    },
    body: {
        id: 'actions.filter.body',
        defaultMessage: 'Get your lights, plugs and sensors working together to make your home work better for you.'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/actions/filter/header/intl.js